export default "__VITE_ASSET__39f34495__"